import { create } from 'zustand';

export interface Toast {
  id: string;
  title: string;
  body?: string;
  actionUrl?: string | null;
}

interface ToastState {
  toasts: Toast[];
  show: (toast: Toast) => void;
  dismiss: (id: string) => void;
}

/** Durée d'affichage d'un bandeau : assez pour le lire, pas assez pour encombrer. */
const TOAST_DURATION_MS = 8_000;

/** Au-delà, les plus anciens cèdent la place : une rafale ne doit pas couvrir l'écran. */
const MAX_TOASTS = 3;

export const useToastStore = create<ToastState>((set, get) => ({
  toasts: [],

  show: (toast) => {
    if (get().toasts.some((existing) => existing.id === toast.id)) {
      return;
    }

    set((state) => ({ toasts: [...state.toasts, toast].slice(-MAX_TOASTS) }));
    window.setTimeout(() => get().dismiss(toast.id), TOAST_DURATION_MS);
  },

  dismiss: (id) => set((state) => ({ toasts: state.toasts.filter((toast) => toast.id !== id) })),
}));
